import React from 'react';
import { useSelector } from 'react-redux';
import DefaultLayer from './default_layer';
import LoginLayer from './login_layer';
import CartLayer from './cart_layer';
import EstimateLayer from './estimate_layer';
import ReviewRegist from './review_regist';
import ReportProductReview from './reportproductreview_layer';
import Share from './share';
// import AlertLayer from '../layer/alert_layer'
import ImageMagnificationLayer from '../layer/imageMagnification_Layer';
import ConfirmLayer from "./confirm_layer";
import SingleLayer from "./single_layer";
import GalleryLayer from "./galleryLayer";
import GalleryShoppingLayer from "./galleryShoppingLayer";
var LayerModel = function () {
    var layer = useSelector(function (state) { return state.layer; });
    var userInfo = useSelector(function (state) { return state.common.userInfo; });
    // const userIdx = ((userInfo&&userInfo.user_idx&&userInfo.user_idx))?userInfo.user_idx:""
    return (React.createElement(React.Fragment, null,
        layer.name && (React.createElement(React.Fragment, null,
            layer.name === 'default' && React.createElement(DefaultLayer, null),
            layer.name === 'login' && React.createElement(LoginLayer, null),
            layer.name === 'cart' && React.createElement(CartLayer, null),
            layer.name === 'estimate' && React.createElement(EstimateLayer, null),
            layer.name === 'reviewRegist' && React.createElement(ReviewRegist, { reviewIndex: layer.data }),
            layer.name === 'reportProductReview' && React.createElement(ReportProductReview, { item_id: layer.data.item_id, review_id: layer.data.review_id, user_id: layer.data.user_id, comment_id: layer.data.comment_id }),
            layer.name === 'imageMagnification' && React.createElement(ImageMagnificationLayer, { imageUrl: layer.data.data, imageIndex: layer.data.index }),
            layer.name === 'share' && React.createElement(Share, null),
            layer.name === 'delete' && React.createElement(ConfirmLayer, { message: layer.data.message, btnTxt: layer.data.btnTxt, action: layer.data.action }),
            layer.name === 'galleryImage' && React.createElement(GalleryLayer, { item_id: layer.data.item_id }),
            layer.name === 'galleryShoppingImage' && React.createElement(GalleryShoppingLayer, { item_id: layer.data.item_id }))),
        layer.validation.name && (React.createElement(React.Fragment, null, layer.validation.name === 'validation' && React.createElement(SingleLayer, { name: layer.validation.name, message: layer.validation.data.message, btnTxt: layer.validation.data.btnTxt })))));
};
export default LayerModel;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/layer/index.tsx
// module id = 280
// module chunks = 0